<template>
  <div>
    <table class="item-rules-grid">
      <thead>
        <tr>
          <th>Item Type</th>
          <th>Accept</th>
          <th>Warn</th>
          <th>Block</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="type in itemTypes"
          :key="type.value"
        >
          <td>{{ type.label }}</td>
          <td>
            <el-radio
              v-model="typeRules[type.value]"
              label="accept"
            />
          </td>
          <td>
            <el-radio
              v-model="typeRules[type.value]"
              label="warn"
            />
          </td>
          <td>
            <el-radio
              v-model="typeRules[type.value]"
              label="block"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="value"
      class="item-rules-expression"
    >
      <code>{{ value }}</code>
    </div>
  </div>
</template>

<script>
const ITEM_TYPES = [
  { value: 1, label: 'Satchel' },
  { value: 2, label: 'Carton' },
  { value: 3, label: 'Pallet' },
  { value: 4, label: 'Skid' },
  { value: 5, label: 'Other' },
  { value: 6, label: 'Virtual DG' },
  { value: 7, label: 'Cage' },
  { value: 8, label: 'Document' }
]

function defaultTypeRules () {
  return ITEM_TYPES.reduce((acc, t) => { acc[t.value] = 'accept'; return acc }, {})
}

export default {
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      itemTypes: ITEM_TYPES,
      typeRules: defaultTypeRules(),
      syncingExpression: false
    }
  },
  watch: {
    typeRules: {
      deep: true,
      handler () {
        this.syncingExpression = true
        this.$emit('input', this.generateExpression())
        this.$nextTick(() => { this.syncingExpression = false })
      }
    },
    value: {
      immediate: true,
      handler (val) {
        if (!this.syncingExpression) {
          this.parseExpression(val)
        }
      }
    }
  },
  methods: {
    generateExpression () {
      const blocked = ITEM_TYPES.map(t => t.value).filter(v => this.typeRules[v] === 'block')
      const warned = ITEM_TYPES.map(t => t.value).filter(v => this.typeRules[v] === 'warn')

      if (!blocked.length && !warned.length) return null

      if (blocked.length && warned.length) {
        return `type in [${blocked.join(', ')}] ? "block" : type in [${warned.join(', ')}] ? "warn" : "accept"`
      }
      if (blocked.length) {
        return `type in [${blocked.join(', ')}] ? "block" : "accept"`
      }
      return `type in [${warned.join(', ')}] ? "warn" : "accept"`
    },
    parseExpression (expr) {
      const rules = defaultTypeRules()

      if (expr) {
        const single = expr.match(/^type in \[([^\]]+)\] \? "(\w+)" : "accept"$/)
        if (single) {
          single[1].split(',').map(s => Number(s.trim())).forEach(id => { rules[id] = single[2] })
        }

        const double = expr.match(/^type in \[([^\]]+)\] \? "(\w+)" : type in \[([^\]]+)\] \? "(\w+)" : "accept"$/)
        if (double) {
          double[1].split(',').map(s => Number(s.trim())).forEach(id => { rules[id] = double[2] })
          double[3].split(',').map(s => Number(s.trim())).forEach(id => { rules[id] = double[4] })
        }

        const notIn = expr.match(/^type not in \[([^\]]+)\] \? "(\w+)" : "accept"$/)
        if (notIn) {
          const listed = notIn[1].split(',').map(s => Number(s.trim()))
          ITEM_TYPES.forEach(t => {
            if (!listed.includes(t.value)) rules[t.value] = notIn[2]
          })
        }
      }

      this.typeRules = rules
    }
  }
}
</script>

<style scoped>
.item-rules-grid {
  width: 100%;
  border-collapse: collapse;
}
.item-rules-grid th,
.item-rules-grid td {
  padding: 6px 12px;
  text-align: center;
  border-bottom: 1px solid #ebeef5;
}
.item-rules-grid th:first-child,
.item-rules-grid td:first-child {
  text-align: left;
}
.item-rules-grid thead th {
  font-weight: 600;
  color: #606266;
  background: #f5f7fa;
}
.item-rules-expression {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}
</style>
